import { delay } from 'redux-saga';
import { fork, all, put, take, select } from 'redux-saga/effects';
import { parse } from 'querystring';
import { LOCATION_CHANGE, push, replace } from 'react-router-redux';

import {
  INITIALISE,
  updateClientName,
} from '@xanadu/ui-shared/modules/application/actions';

import { IS_MOBILE } from '@xanadu/ui-shared/constants';
import { getStreamInfo } from '@xanadu/ui-shared/modules/streaming/actions';
import { registrationRequest } from '@xanadu/ui-shared/modules/userRegistration/actions';
import { track } from '@xanadu/ui-shared/interfaces/woopra';
import { loginRequest } from '@xanadu/ui-shared/modules/userSession/actions';
import { showResetPassword } from '@xanadu/ui-shared/modules/user/actions';
import { resetPasswordModalRequest } from '@xanadu/ui-shared/modules/resetPassword/actions';
import { startTourMode, toggleCustomerOnboardingPopup } from '../customerOnboarding/actions';
/** App initialization entry point.
 *  All external module's actions should be here to avoid fragmented app's INITIALISE sagas
 */
function* watchForAppInitialize() {
  const { payload } = yield take(INITIALISE);

  yield put(updateClientName(payload.brand));

  yield put(getStreamInfo());
}

function* watchLocationChanges() {
  while (true) {
    const { payload } = yield take(LOCATION_CHANGE);
    const { pathname, search } = payload;
    const isLoggedIn = yield select((state) => state.getIn(['user', 'isLoggedIn']));
    const product = yield select((state) => state.getIn(['application', 'product'], []));

    if (pathname.indexOf('registration') > -1) {
      if (isLoggedIn) {
        yield put(push('/'));
      } else {
        yield put(
          registrationRequest({ show: true, promoRegistrationImage: null, checked: false })
        );

        track('Registration', 'Registration opened', {
          description: 'url',
          product,
        });
      }
    }

    if (pathname.indexOf('login') > -1) {
      yield put(loginRequest(true));
    }

    if (pathname.indexOf('reset-password') > -1) {
      yield put(showResetPassword(true));
      yield put(loginRequest(true));
    }

    if (pathname.indexOf('update-password') > -1) {
      const urlParams = search ? parse(search.substring(1)) : {};
      yield put(resetPasswordModalRequest(urlParams));

      yield delay(400);
      yield put(push('/'));
    }

    if (pathname.startsWith('/tour')) {
      yield put(replace('/'));
      yield delay(1000);

      if (IS_MOBILE) {
        yield put(toggleCustomerOnboardingPopup({
          visible: true,
          firstTimeVisitor: false,
          forceTour: true,
        }));
      } else {
        yield put(startTourMode());
      }
    }
  }
}

export default function* root() {
  yield all([
    fork(watchForAppInitialize),
    fork(watchLocationChanges),
  ]);
}
